<template>
    <div>
        <v-dialog
            content-class="dialog-custom"
            v-model="dialog"
            persistent
            width="400px"
        >
            <v-card light v-if="!loading">
                <v-card-title>
                    <div class="dialog-header-custom">
                        <div>
                            <v-btn
                                class="closeButton mx-2"
                                icon
                                title="Close Form"
                                @click="handleClose"
                            >
                                <v-icon style="color: #4f4f4f !important" class="material-icons-round"> close </v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class = "logoutContainer">
                        <p class = "logoutText">Logout</p>
                        <p class = "sureLogoutText">Are you sure you want to logout?</p>
                        <div class = "buttonContainer">
                            <button class="buttonCancel btn_new btn-secondary-new" @click="handleClose">No, Cancel </button>
                            <button class="buttonSubmit btn_new btn-secondary-new" @click="redirectToLogin()">Yes, Confirm </button>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-overlay :value="loading">
            <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
export default {
    name: 'LogOutDialog',
    props: {
        LogOutDialog: Boolean
    },
    data () {
        return {
            dialog: this.LogOutDialog,
            loading: false
        }
    },
    methods: {
        handleClose () {
            this.$emit('closeHandleDialog')
        },
        redirectToLogin () {
            this.$store.dispatch('logout')
            this.$router.push('/login')
        }
    }
}
</script>
<style lang="scss" scoped>

.buttonContainer {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.buttonCancel {
  height: 40px !important;
  background: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
  font-size: 14px !important;
  color: #232323 !important;
  margin-right: 10px !important;
  width: 120px !important;
}
.buttonSubmit {
  height: 40px !important;
  font-size: 14px !important;
  margin-left: 20px !important;
  width: 120px !important;
}
.closeButton {
    position: absolute;
    right: 0px
}
.sureLogoutText {
    font-weight: 400;
    font-size: 14px;
    color: #4F4F4F;
}
.logoutText {
    padding-bottom: 10px;
    font-weight: 600;
    font-size: 20px;
    color: #232323;
}
.logoutContainer {
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.dialog-custom {
    background: #ffffff;
    border: 1px solid #b9b9bb !important;
    box-sizing: border-box !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 20px !important;
    max-width:30%;
    @media screen and (max-width: 400px) {
        max-width:10%;
    }
    .v-card__actions {
        padding: 20px !important;
    }
}

.v-text-field .v-label {
    font-weight: bold !important;
}
.dialog-header-custom {
    position:relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
}

.custom-btn-common {
    width: 150px;
    font-size: 14px;
    text-transform: none;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 22px;
}

.custom-btn {
    background-color: #fbc100 !important;
    font-size: 14px;
    text-transform: none;
    color: white;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;

    .v-icon {
        font-size: 14px;
        margin-left: 16px;
    }
}

.v-card__title {
    .v-icon.v-icon {
        color: #fbc100;
        padding: 8px 8px 8px 0px;
    }
}

.v-card__text {
    color: $primary !important;
}

.v-card__actions {
    justify-content: flex-end;
}
</style>
